
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/events/[singleEvents]",
      function () {
        return require("private-next-pages/events/[singleEvents].jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/events/[singleEvents]"])
      });
    }
  